import { render } from "./Categories.vue?vue&type=template&id=6c25e758&scoped=true&ts=true"
import script from "./Categories.vue?vue&type=script&lang=ts"
export * from "./Categories.vue?vue&type=script&lang=ts"

import "./Categories.vue?vue&type=style&index=0&id=6c25e758&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c25e758"]])

export default __exports__